import { ITableModeloEquipoEdit } from "../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const PostTableEquipoModelo = (data: Ifilter) => {
  return fetchListVerificacion.post("EquipoModelo/listarTable", data);
};
const GetEquipoModeloAuxiliar = (request: Ifilter,controller = new AbortController()) => {
  return fetchListVerificacion.get("EquipoModelo/ComboEquipoModeloAuxiliar", {
    params: request,
    signal: controller.signal,
});
};

const PostListarCombo = (
  search: any,
  controller = new AbortController()
) => {
  return fetchListVerificacion.post("EquipoModelo/ListarCombo", search, {
    signal: controller.signal,
  } );
};

const PostCrearEquipoModelo = (request: any) => {
  return fetchListVerificacion.post(
    "EquipoModelo/CrearEquipoModelosCommand",
    request
  );
};
const PutEditarEquipoModelosCommand = (request: ITableModeloEquipoEdit) => {
  return fetchListVerificacion.put(
    "EquipoModelo/EditarEquipoModelosCommand",
    request
  );
};
const DeleteEquipoModelosCommand = (equipoModeloId:string) => {
  return fetchListVerificacion.delete(
    "EquipoModelo/EliminarEquipoModelosCommand?EquipoModeloId="+equipoModeloId
  );
};

const EquipoModeloService = {
  PostTableEquipoModelo,
  PostListarCombo,GetEquipoModeloAuxiliar,
  PostCrearEquipoModelo,PutEditarEquipoModelosCommand,DeleteEquipoModelosCommand
};

export default EquipoModeloService;
